<template>
  <div class="homepage_wrap">
    <routerCom btnIndex="1" secViewName="中智鼎证App" :changePop="changePop"/>
    <div class="imgArr">
      <div class="title">
        <span>中智鼎证</span>
        <span style="color:#bb0000;">APP</span>
      </div>
      <div style="width:80% ;margin:32px auto 0 auto;text-align: center;font-size: 14px;color: darkgray">中智鼎证APP是一个涵盖汽车电子取证各领域和环节的综合工具及社区，提供包括但不限于EDR检测、VDR检测在内的多项功能及社区服务，帮助用户在汽车电子取证的各个领域和场景有效提升效率和体验。</div>
      <div>
        <el-button :onClick="download" style="margin-top: 20px;" size="large" color="#C80000">
          <el-icon><Download /></el-icon>下载软件</el-button>
      </div>
      <img src="../../assets/img/app/app3.png" alt="" />
      <img src="../../assets/img/home/infoBg.png" alt="" />
    </div>
  </div>
</template>

<script>
import routerCom from '../routerCom.vue'
export default {
  name: 'appInfoApp',
  components:{
    routerCom,
  },
  props: {
    isPopShow:Function
  },
  methods: {
		funRouter() {
			this.$router.push("/appCenter");
		},
    download(){
      // window.open('http://8.140.49.120//zdedr_v18100.msi')
      alert("请联系我们获取")
    },
    changePop(isp){
      this.isPopShow(isp);
    }
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

.homepage_wrap {
	width: 1280px;
	margin:auto;
  text-align: center;
}

.imgArr{
  margin-top: 48px;
  max-width: 1280px;
  margin:50px auto;
  text-align: center;

  display: flex;
  flex-direction: column;
}

.imgArr img{
  margin: 32px auto 0 auto;
  max-width: 1280px;
}

.text{
  text-align: left;
  height: 100%;
}

.text .text-title{
  font-family: Noto Sans SC;
  font-size: 20px;
  font-weight: 400;
  line-height: 20px;
  color: #131313;

  margin-top: 63px;
}

.text .text-info{
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 28px;
  color: #9E9E9E;

  margin-top: 20px;
}

.title{
  margin-top: 40px;
  font-size: 34px;
  //color: #bb0000;
}
</style>
